module.exports = __webpack_public_path__ + "static/media/bd3419ba-d795-426f-ae33-3443113adc63.e222a740.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/competence/bd3419ba-d795-426f-ae33-3443113adc63.png
// module id = 1472
// module chunks = 0